module.exports = __webpack_public_path__ + "static/media/hero.f112c368.png";